// extracted by mini-css-extract-plugin
export default {"button":"buttonDelete_button__KUpnD"};